import React from 'react';
import { useController, Control, FieldValues, Path } from 'react-hook-form';

interface RHFInputTextProps<T extends FieldValues> {
  name: Path<T>;
  control: Control<T>;
  label: string;
  required?: boolean;
  disabled?: boolean;
  type?: string;
  placeholder?: string;
  className?: string;
}

export function RHFInputText<T extends FieldValues>({
  name, control, label, required, disabled, type = 'text', placeholder, className
}: RHFInputTextProps<T>) {
  const { field, fieldState } = useController({ name, control });

  return (
    <div className={`fv-row mb-5 ${className || ''}`}>
      <label className={`form-label ${required ? 'required' : ''}`}>{label}</label>
      <input
        className={`form-control ${fieldState.error ? 'is-invalid' : ''}`}
        type={type}
        autoComplete="off"
        placeholder={placeholder}
        disabled={disabled}
        value={field.value ?? ''}
        onChange={field.onChange}
        onBlur={field.onBlur}
        ref={field.ref}
      />
      {fieldState.error && (
        <div className="fv-plugins-message-container invalid-feedback">
          {fieldState.error.message}
        </div>
      )}
    </div>
  );
}
